"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pooledColostrumReplacer = void 0;
const roundOff_1 = require("./utils/helpers/roundOff");
const graphql_1 = require("../graphql");
const previousPsValueCalculation_1 = require("./utils/helpers/previousPsValueCalculation");
const CustomError_1 = require("./utils/CustomError");
const pooledColostrumReplacer = ({ unit: PA, desiredMaxAmtForFirstFeeding: PB, desiredMaxAmtForSecondFeeding: PC, igGInColostrumReplacer: PD, birthBodyWt: PE, brixReading: PF, brixUsedInPrevCalculation: PG, noOfFirstFeedingCalves: PH, noOfSecondFeedingCalves: PI, }) => {
    if (PB < 2 || PB > 5) {
        throw new CustomError_1.CustomError('OUT OF NORMAL RANGE');
    }
    if (PC < 1) {
        throw new CustomError_1.CustomError('OUT OF NORMAL RANGE');
    }
    if (PC > PB) {
        throw new CustomError_1.CustomError('This must be = or less than first feeding');
    }
    const PAj = PA === graphql_1.Enum_Measurement_System_Enum.UsCustomary ? PE : PE * 2.2046;
    if (PAj < 50 || PAj > 130) {
        throw new CustomError_1.CustomError('OUT OF NORMAL RANGE');
    }
    /**
     * Row PL calculations
     */
    const Po = PA === graphql_1.Enum_Measurement_System_Enum.UsCustomary
        ? PE * 1.6666 + 150
        : PE * 2.2046 * 1.6666 + 150;
    const Pj = 6.94;
    const Pk = -96.5;
    const Pl = Pj * PF + Pk < 0 ? 1 : Pj * PF + Pk;
    const Pm = Pl * 0.94635;
    const Pn = PA === graphql_1.Enum_Measurement_System_Enum.UsCustomary ? Pm : Pl;
    if (Pn === 0) {
        throw new CustomError_1.CustomError('Denominator cannot be 0 Check for field "Pn"');
    }
    const Py = (0, roundOff_1.default)(Po / Pn, 1);
    const PL = Py > PB ? PB : Py;
    /**
     * Row PM calculations
     */
    const Pi = Po / Pn;
    const PJ = Pi > PB ? 2 : 1;
    const Px = Py < PB ? 0 : (Po - PB * Pn) / Pn;
    if (Px > 2 * PB) {
        throw new CustomError_1.CustomError('Combination of volume and colostrum quality too low - use colostrum replacer', CustomError_1.CustomErrorTypeEnum.Warning);
    }
    else if (PG < 18) {
        throw new CustomError_1.CustomError('Colostrum quality too low in previous feeding, use colostrum replacer for 2nd feeding', CustomError_1.CustomErrorTypeEnum.Warning);
    }
    const PAC = (0, roundOff_1.default)(Px, 1) > PB ? PB : (0, roundOff_1.default)(Px, 1);
    const PAD = PAC + PB - (PB + PC) < 0 ? 0 : PAC + PB - (PB + PC);
    const Pz = Py - PB;
    const PAA = Po - (Po - Pz * Pn);
    let PU;
    if (PAC > PC) {
        PU = PC;
    }
    else {
        PU = (0, roundOff_1.default)(Px, 1) > PB ? PB : (0, roundOff_1.default)(Px, 1);
    }
    if (PU === undefined) {
        throw new CustomError_1.CustomError('Error: Check for field "PU"');
    }
    const PAB = PU * Pn;
    const PAG = (PAA - PAB) / PJ;
    const Pw = PA === graphql_1.Enum_Measurement_System_Enum.UsCustomary ? (PD / 100) * 453 : PD;
    if (Pw === 0) {
        throw new CustomError_1.CustomError('Denominator cannot be 0 Check for field "Pw"');
    }
    let PAH;
    if (PAD < 0) {
        PAH = 0;
    }
    else {
        PAH =
            PA === graphql_1.Enum_Measurement_System_Enum.UsCustomary
                ? (0, roundOff_1.default)(PAG / Pw, 2)
                : (0, roundOff_1.default)(PAG / (Pw / 100), 0);
    }
    if (PAH === undefined) {
        throw new CustomError_1.CustomError('Error: Check for field "PAH"');
    }
    const Pd = PAH > 0 ? PAH : 0;
    const PAE = PB / (PB + PC);
    const PM = PA === graphql_1.Enum_Measurement_System_Enum.UsCustomary
        ? (0, roundOff_1.default)(PJ * Pd * PAE, 2)
        : (0, roundOff_1.default)(PJ * Pd * PAE, 0);
    /**
     * Row PN calculations
     */
    const PAI = (0, previousPsValueCalculation_1.default)({ PA, PB, PC, PD, PE, PG, Pi });
    const Pr = Pn * PL + Pw * PM;
    if (PL === 0) {
        throw new CustomError_1.CustomError('Denominator cannot be 0 Check for field "PL"');
    }
    const Pu = Pr / PL;
    if (Pu === 0) {
        throw new CustomError_1.CustomError('Denominator cannot be 0 Check for field "Pu"');
    }
    const Pp = (0, roundOff_1.default)(PAI / Pu, 1);
    const PN = Pp;
    /**
     * Row PO calculations
     */
    let PO = (PM / PL) * PN;
    PO = PA === graphql_1.Enum_Measurement_System_Enum.UsCustomary ? (0, roundOff_1.default)(PO, 2) : (0, roundOff_1.default)(PO, 0);
    /**
     * Row PP calculations
     */
    const PP = PL * PH + PI * PN;
    /**
     * Row PQ calculations
     */
    const PQ = PA === graphql_1.Enum_Measurement_System_Enum.UsCustomary ? PP / 4 : '';
    /**
     * Row PT calculations
     */
    const PT = PM * PH + PO * PI;
    /**
     * Row PR calculations
     */
    const Pa = PA === graphql_1.Enum_Measurement_System_Enum.UsCustomary ? PT : PT / 453.6;
    const PX = PP / 0.94635;
    const PW = PP;
    const PY = PA === graphql_1.Enum_Measurement_System_Enum.UsCustomary ? PW : PX;
    const Pe = 0.7859 * PF + 4.9159;
    const PZ = PY * (2.125 + 0.008 * Pe);
    const Pb = 0.6 * Pa + PZ;
    if (Pb === 0) {
        throw new CustomError_1.CustomError('Denominator cannot be 0 Check for field "Pb"');
    }
    const Pc = PZ / Pb;
    const PR = PT === 0 ? '' : Pc * PP;
    /**
     * Row PS calculations
     */
    let PS = '';
    if (PT === 0) {
        PS = '';
    }
    else {
        PS = PQ === '' ? '' : Pc * Number(PQ);
    }
    const PAk = PA === graphql_1.Enum_Measurement_System_Enum.UsCustomary ? '' : PT / 1000;
    return {
        minAmtNeededInFirstFeeding: PL,
        crPowderNeededInFirstFeeding: PM,
        amtNeededInSecondFeeding: PN,
        amtOfCrUsedInSecondFeeding: PO,
        totalAmtNeeded: PP,
        unitForTotalNeeded: PQ !== '' ? (0, roundOff_1.default)(PQ, 1) : PQ,
        amtNeededBeforeCrAdd: PR !== '' ? (0, roundOff_1.default)(PR, 1) : PR,
        unitBeforeCrAddition: PS !== '' ? (0, roundOff_1.default)(PS, 1) : PS,
        amtOfCrPowderNeeded: PT,
        unitForCrPowderNeeded: PAk !== '' ? (0, roundOff_1.default)(PAk, 2) : PAk,
    };
};
exports.pooledColostrumReplacer = pooledColostrumReplacer;
exports.default = null;
//# sourceMappingURL=pooledColostrumReplacer.js.map